import React from "react";

function ChatGroupHeader({ chatsName, showSelectedChats }) {
  return (
    <div className="header author border-bottom justify-content-between">
      <span className="u-text-limit">Enviar mensagem para: {chatsName}</span>
      <div className="d-flex flex-row align-center position-relative">
        <div className="navigation">
          <ul className="ml-20">
            <li>
              <a href="#" onClick={showSelectedChats}>Mostrar</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ChatGroupHeader;

